import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Mark } from "../assets/brand/rr-mark.svg";

// Логотип: монограмма RR + название. Цвет берётся из CSS (currentColor)
export function Brand({ sub = "Dubai · Istanbul", onClick }) {
  return (
    <Link to="/" className="brand" onClick={onClick} aria-label="RR Consulting & Property">
      <Mark className="brand__mark" aria-hidden="true" />
      <span className="brand__text">
        <span className="brand__name">RR Consulting</span>
        <span className="brand__sub">& Property · {sub}</span>
      </span>
    </Link>
  );
}

// Плавное появление блока при прокрутке
export function Reveal({ as: Tag = "div", className = "", delay = 0, children, ...rest }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (!("IntersectionObserver" in window)) {
      el.classList.add("is-visible");
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("is-visible");
          io.disconnect();
        }
      },
      { rootMargin: "0px 0px -8% 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <Tag ref={ref} className={`reveal ${className}`} style={delay ? { transitionDelay: `${delay}ms` } : undefined} {...rest}>
      {children}
    </Tag>
  );
}

export function Eyebrow({ children, light, line }) {
  return <span className={`eyebrow ${light ? "eyebrow--light" : ""} ${line ? "eyebrow--line" : ""}`}>{children}</span>;
}
